import { CreateAccountWizard } from 'components/CreateAccountWizard'
import React from 'react'
import { Container, Row } from 'react-bootstrap'

const CreateAccount = () => {
    return (
        <>
            <Container>
                <Row>
                    <CreateAccountWizard />
                </Row>
            </Container>
        </>
    )
}

export default CreateAccount
